import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Form = styled.form`
  padding: 0 ${spacing(20)};

  @media ${media.maxWidth.sm} {
    padding: 0;
  }
`;

export const $SubmitButton = styled(Button)`
  margin-top: ${spacing('xl')};
`;

export const $InputRow = styled.div`
  margin-bottom: ${spacing(5)};
`;

export const $Row = styled(Row)`
  margin-bottom: ${spacing(5)};
`;

export const $Preview = styled.div`
  ${fontStyle('xs')};
  font-weight: ${fontWeight('medium')};
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
  margin-bottom: ${spacing('sm')};
`;

export const $BannerMessage1 = styled.div`
  display: inline;
`;

export const $Bold = styled.div`
  display: inline;
  font-weight: ${fontWeight('bold')};
`;

export const $BannerContainer = styled.div`
  margin-bottom: ${spacing('sm')};

  > div {
    margin: 0;
    max-width: fit-content;
  }
`;

export const $MainDomainName = styled.div`
  font-weight: ${fontWeight('bold')};
  color: ${({ theme }) => theme.newUI.variationColors.dark1};
`;

export const $DomainName = styled.div`
  display: inline-flex;
`;
